<template>
    <div class="container">
        <div class="detail-box">
            <div class="detail-left"><img :src="detail.cover" alt="" srcset=""> </div>
            <div class="detail-right">
                <h3>{{ detail.title }}</h3>
                <div class="detail-right-desc">
                    <p><img src="@/assets/imgs/fire.png" alt="" srcset="">{{ detail.readNum }}</p>
                    <p>作者：{{ detail.author }}</p>
                    <p> <i v-for="tag in detail.tags" :key="tag">{{ tag }}</i> </p>
                </div>
                <div class="detail-right-btns flex ">
                    <el-button class="green-btn" @click="handleRead(detail)">开始阅读</el-button>
                    <!-- <el-button>分享图书</el-button> -->
                    <div class="detail-dz" @click="handleDz(detail)">
                        <img v-if="!isDz" src="@/assets/imgs/dz.png" alt="">
                        <img v-else src="@/assets/imgs/dz-checked.png" alt="">
                        <label>{{ detail.likeNum }}</label>
                    </div>
                </div>
                <div class="detail-right-con">
                    <h4>内容简介</h4>
                    <p>{{ detail.description }}</p>
                </div>
            </div>
        </div>
        <!--  书籍推荐      -->
        <div v-if="recommendLists.length" class="recommend-box">
            <h3>书籍推荐</h3>
            <ul>
                <li v-for="item in recommendLists" :key="item.id" @click="handleDetail(item)">
                    <img :src="item.cover" alt="封面" srcset="">
                    <p class="line-clamp1">{{ item.title }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>


// 获取详情
import { reactive, toRefs, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';

import { getEbookDetail, getEbookLists, addEbookLike } from '@/api/index.js';
const router = useRouter();
const detail = ref({});
const recommendLists = ref([]);
const isDz = ref(false);

const getDetail = (id) => {
    getEbookDetail({ id }).then(({ data }) => {
        console.log('获取详情', data);
        detail.value = data;
    });
};

const handleRead = (item) => {
    // 这里可以添加阅读逻辑，比如跳转到阅读页面
    console.log('开始阅读', item);
    router.push('/readBook?url=' + item.url + '&title=' + item.title);
};

/** 详情页的跳转**/
const handleDetail = (item) => {
    router.push('/bookDetail?id=' + item.id);
};
const handleDz = (item) => {
    // 点赞逻辑
    console.log('点赞', item);
    isDz.value = true;
    // 这里可以添加点赞的 API 调用
    addEbookLike({ id: item.id }).then(() => {
        getDetail(item.id); // 刷新详情页数据
        $message.success('点赞成功');
    });
};


const getLists = async () => {
    getEbookLists({
        pageNo: 1,
        pageSize: 5
    }).then(({ data }) => {
        recommendLists.value = data.list || [];
    });
};

onMounted(() => {
    const route = useRoute();
    const id = route.query.id;
    if (id) {
        getDetail(id);
    }
    getLists();
});

</script>

<style lang="scss" scoped>
.detail-box{
    display: flex;
    margin: 30px auto;
    background: #ffffff;
    .detail-left{
        width: 507px;
        height: 714px;
        background: #af4d3a;
        padding: 30px;
        box-sizing: border-box;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .detail-right{
        background: #ffffff;
        flex: 1;
        padding: 60px;
        h3{
            color:#313131;
            font-size:34px;
            margin-bottom: 69px;
            font-weight: 500;
        }
        .detail-right-desc{

            p{
                font-size: 14px;
                &:nth-child(1){
                    color:#ec2e2e;
                    font-size:18px;
                    margin-bottom: 23px;
                    img{
                        width: 15px;
                        height: 18px;
                        margin-right: 5px;
                    }
                }
               &:nth-child(2){
                   font-family:Source Han Sans CN;
                   color:#313131;
                   font-size:17px;
                   margin-bottom: 36px;
               }
               &:nth-child(3){
                   i{
                       font-style: normal;
                       border:1px solid #707070;
                       border-radius:17px;
                       padding: 2px 10px;
                       color:#313131;
                       font-size:17px;
                       margin-right: 5px;
                   }
               }
            }
        }

        .detail-right-btns{
            margin-top: 43px;
            margin-bottom: 53px;
            align-items: center;
            button{
                color: #707070;
                border-color: #707070;
                border-radius: 0 !important;
            }
            .green-btn{
                color: #188b97 !important;
                border-color: #188b97 !important;
            }
            .detail-dz{
                padding-left: 20px;
                label{
                    color: #313131;
                    font-size: 22px;
                    position: relative;
                    top: 8px;
                }
                img{
                    width: 40px;
                    margin-right: 10px;
                    vertical-align: middle;
                }
            }
        }

        .detail-right-con{
            h4{
                color:#2e2e2e;
                font-size:20px;
                margin-bottom: 30px;
                font-weight: 500;
            }
            p{
                color:#313131;
                font-size:16px;
                line-height: 25px;
            }
        }
    }
}
.recommend-box{
    margin: 30px auto;
    h3{
        font-family:Source Han Sans CN;
        color:#313131;
        font-size:28px;
        margin-bottom: 21px;
        font-weight: 500;
    }
}
ul{
    display: grid;
    grid-template-columns: repeat(4, 290px);
    gap: 10px;
    margin: auto;
    justify-content: center;
    li{
        background: #ffffff;
        padding: 17px;
        box-sizing: border-box;
        padding-bottom: 55px;
        cursor: pointer;
        img{
            width: 257px;
            height: 340px;
        }
        p{
            color:#2e2e2e;
            font-size:24px;
            margin-top: 15px;
        }

    }
}
</style>
